import {ref, onMounted, onUnmounted} from '@vue/composition-api';

const useUnsavedOnClose = (shop) => {


    const cachedData = ref(null)
    const newShop = ref(null)

    const formDataForComparison = (x) => {
        return JSON.stringify(x);
    }

    const setCachedData = (shop) => {
        cachedData.value = formDataForComparison(shop);
    }

    const setShopChanges = sh => newShop.value = sh

    const handlerClose = (e) => {
        if(cachedData.value !== formDataForComparison(newShop.value)) {
            e.preventDefault();
            e.returnValue = '';
        }
    }
    
    onMounted(() => {
        setCachedData(shop)
        window.addEventListener('beforeunload', handlerClose);
    })

    onUnmounted(() => {
        window.removeEventListener('beforeunload', handlerClose);
    })

    return {
        formDataForComparison,
        cachedData,
        handlerClose,
        setShopChanges,
        setCachedData
    }
}

export default useUnsavedOnClose